// perf.ts — Client perf telemetry: a (reconnecting) WebSocket to the server for
// reporting frame timing, plus a shared snapshot the HUD overlay reads each tick.
export interface PerfSnapshot {
  fps: number;
  dropped: number;
  p95Ms: number;
  maxMs: number;
}

export const latestPerf: PerfSnapshot = { fps: 0, dropped: 0, p95Ms: 0, maxMs: 0 };

export interface TelemetrySocket {
  send: (data: object) => void;
}

export function telemetrySocket(): TelemetrySocket {
  let ws: WebSocket | null = null;

  const connect = () => {
    const proto = location.protocol === 'https:' ? 'wss' : 'ws';
    const sock = new WebSocket(`${proto}://${location.host}/api/telemetry`);
    sock.onopen = () => {
      ws = sock;
    };
    sock.onclose = () => {
      ws = null;
      window.setTimeout(connect, 5000);
    };
    sock.onerror = () => {
      try {
        sock.close();
      } catch {
        // ignore
      }
    };
  };
  connect();

  return {
    send: (data) => {
      if (ws && ws.readyState === WebSocket.OPEN) {
        ws.send(JSON.stringify(data));
      }
    },
  };
}
